import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'of-landing',
  imports: [],
  template: ''
})
export class LandingComponent implements OnInit {
  private router = inject(Router);

  ngOnInit(): void {
    const returnUrl = sessionStorage.getItem('of_return_url');
    sessionStorage.removeItem('of_return_url');
    if (returnUrl) {
      this.router.navigateByUrl(returnUrl);
    } else {
      this.router.navigate(['/dashboard']);
    }
  }
}
